import React from "react";
import { Column, Row } from "simple-flexbox";

const Component3 = () => {
    return (
        <>
            <div className="row objectifs2050">
                <div className="column col1">
                    <h3>
                        Compenser
                        <br />
                        les 20 % d'émissions
                        <br />
                        résiduelles
                    </h3>
                    <img
                        className="my-2"
                        src={
                            process.env.REACT_APP_API_URL + "/img/immeuble.svg"
                        }
                    />
                </div>
                <div className="column col2">
                    <h4>Gaz à effet de serre</h4>
                    <div className="row row1">
                        <div className="column">
                            <img
                                src={
                                    process.env.REACT_APP_API_URL +
                                    "/img/gaz2.svg"
                                }
                            />
                        </div>
                        <div className="column pl-3">
                            <span>Zéro</span>
                            <br />
                            émission de gaz à effet de serre sur notre parc.
                        </div>
                    </div>
                    <h4 className="">Empreinte carbone</h4>
                    <div className="row">
                        <div className="column">
                            <img
                                src={
                                    process.env.REACT_APP_API_URL +
                                    "/img/emp2.svg"
                                }
                            />
                        </div>
                        <div className="column pl-3">
                            <span>-80%</span>
                            <br />
                            de l'empreinte carbone d'Élogie-Siemp.
                        </div>
                    </div>
                </div>
                <div className="column col3">
                    <h4>EnR</h4>
                    <div className="row row1">
                        <div className="column">
                            <img
                                src={
                                    process.env.REACT_APP_API_URL +
                                    "/img/enr2.svg"
                                }
                            />
                        </div>
                        <div className="column pl-3">
                            <span>100%</span>
                            <br />
                            dans la consommation du parc d'Élogie-Siemp dont 20%
                            produites localement.
                        </div>
                    </div>
                    <h4 className="">Consommations énergétiques</h4>
                    <div className="row">
                        <div className="column">
                            <img
                                src={
                                    process.env.REACT_APP_API_URL +
                                    "/img/conso2.svg"
                                }
                            />
                        </div>
                        <div className="column pl-3">
                            <span>-50%</span>
                            <br />
                            de consommations énergétiques sur le parc
                            Élogie-Siemp par rapport à 2018.
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Component3;
